import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import InfoServicios from "../../Funciones/InfoServicios";

function CreaServicios(props) {
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [country, setCountry] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [st, setSt] = useState([]);
  const [stateid, setStateid] = useState("");
  const [postComentarios, setPostComentarios] = useState([]);

  useEffect(() => {
    const getcountry = async () => {
      const rescountry = await fetch(
        "https://suadesarrollo.azurewebsites.net/Api/ObtenerServiciosHospitalarios",
      );
      const rescon = await rescountry.json();
      setCountry(await rescon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcountryid = event.target.value;
    setCountryid(getcountryid);
  };

  useEffect(() => {
    if (countryid != "") {
      const getstate = async () => {
        const resstate = await fetch(
          "https://suadesarrollo.azurewebsites.net/api/ObtenerDescripcionServicio/" +
            countryid,
        );
        const resst = await resstate.json();
        setSt(await resst);
      };
      getstate();
    }
  }, [countryid]);

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };
  const fecha = new Date();
  const añoActual = fecha.getFullYear();
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaServicios",
      data: {
        servicioId: countryid,
        descripcionServicio: stateid,
        institucionId: cookie.get("institucionid"),
        fechaCorte: JSON.stringify(añoActual),
        sedeId: props.sedeId,
        comentarios: postComentarios + "",
        complejidad: props.complejidad,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Añadido con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear Institucion " + error);
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Añadir servicios
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Añadir servicio
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <div class="card-header py-3">
                              <h6 class="m-0 font-weight-bold text-primary">
                                SERVICIO
                              </h6>
                            </div>
                            <select
                              className="btn btn-secondary btn-user btn-block text-left"
                              onChange={(e) => handlecountry(e)}
                            >
                              <option value="0">Seleccione </option>
                              {country.map((getcon, index) => (
                                <option key={index} value={getcon.id}>
                                  {getcon.nombreServicio}{" "}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="card-header py-3">
                              <h6 class="m-0 font-weight-bold text-primary">
                                DETALLE DEL SERVICIO{" "}
                              </h6>
                            </div>
                            <select
                              className="btn btn-secondary btn-user btn-block text-left"
                              onChange={(e) => handlestate(e)}
                            >
                              <option value="0">Seleccione </option>
                              {st.map((getst, index) => (
                                <option key={index} value={getst.id}>
                                  {getst.nombre}{" "}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>
                        {stateid == 20 ||
                        stateid == 23 ||
                        stateid == 25 ||
                        stateid == 33 ||
                        stateid == 34 ||
                        stateid == 39 ? (
                          <td>
                            <label for="exampleFormControlTextarea1">
                              Comentarios
                            </label>

                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              rows="6"
                              onChange={(e) =>
                                setPostComentarios(e.target.value)
                              }
                            ></textarea>
                          </td>
                        ) : (
                          <h></h>
                        )}
                      </tbody>
                    </table>
                    <hr />
                    <a>
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaServicios;
